import { isLocalDev } from '../platform/environment';
import { defaultTenantConfig, defaultConfig } from './config.default';

// const isInGrey = checkTranslateFG(FeatureGateKeys.MEEGO_PLATFORM_CHANGE_DOMAIN);
// const isInGrey = true;

// const host = isInGrey ? 'https://meego.larkoffice.com':'https://meego.feishu.cn';
const host = /*#__PURE__*/ (() => window.location.origin)();
const config = /*#__PURE__*/ (() => ({
  ...defaultConfig,

  region: 'cn',
  avatarDomain: `${host}/goapi`,
  host: isLocalDev ? '' : host,
  hostForGo: isLocalDev ? '/goapi' : `${host}/goapi`,
  collectHost: 'https://miigo-monitor.bytedance.com/inner',

  guideLink: 'https://bytedance.feishu.cn/docs/doccnhGBz5VDr5xFsGV9bGgcpwe',
  currentHost: host,
  tosBucket: 'ad-qa-mission',
  // larkLoginHost: 'https://www.feishu.cn',
  larkLoginHost: host.replace('meego', 'www'),
  tenantConfig: defaultTenantConfig,
  bytereplayEnv: 'PROD-INTERNAL',
  labProjectId: '620b229097e53d8b28d33e98',
  labViewId: 'bpcVAgB7RZ',
  showTenantIds: '1',
  internalApi: host.replace('https://meego', 'internal-api-lark-api'),
  passportApi: host.replace('https://meego', 'passport'),
  applinkApi: host.replace('https://meego', 'applink'),
}))();

export default config;
